import moment from "moment";
import { FormatInvoiceDecimalNumber } from "./timeLiveFunction";

export function setTimesheetStatus(approved: boolean, rejected: boolean, submitted: boolean) {
    if (rejected) {
        return { class: "badge-light-danger", text: "Rejected" };
    } if (approved) {
        return { class: "badge-light-success", text: "Approved" };
    } else if (submitted) {
        return { class: "badge-light-primary", text: "Submitted" };
    } else {
        return { class: "badge-light-warning", text: "Not Submitted" };
    }
}

export function displayValueForTimeEntry(value: number, isTimesheetPolicy: boolean, decimalFormat: boolean) {
    if (value === null) {
        return isTimesheetPolicy ? "" : (decimalFormat ? "0.00" : "00:00");
    }
    return isTimesheetPolicy ? value.toFixed(2) : getTimeFromDecimal(value, decimalFormat);
}

// export function displayValueForTimeEntry(
//     value: number | null,
//     isTimesheetPolicy: boolean,
//     decimalFormat: boolean,
//     cultureInfoName: string = "en-US",
//     decimalPlaces: number = 2
// ) {

//     if (value === null) {
//         return isTimesheetPolicy
//             ? ""
//             : (decimalFormat
//                 ? FormatInvoiceDecimalNumber(cultureInfoName, 0, decimalPlaces)
//                 : "00:00");
//     }

//     return isTimesheetPolicy
//         ? (decimalFormat
//             ? FormatInvoiceDecimalNumber(cultureInfoName, value, decimalPlaces)
//             : value.toFixed(decimalPlaces))
//         : (decimalFormat
//             ? FormatInvoiceDecimalNumber(cultureInfoName, value, decimalPlaces)
//             : getTimeFromDecimal(value, decimalFormat));
// }






export function convertDecimalToTimeOnValidation(value: number, isTimesheetPolicy: boolean, decimalFormat: boolean) {
    if (value === null) {
        return isTimesheetPolicy ? "" : (decimalFormat ? "0.00" : "00:00");
    }
    if (isTimesheetPolicy) {
        return value.toFixed(2);
    } else {
        if (decimalFormat) {
            const valSplit = value.toFixed(2).toString().split(".");
            if (valSplit[0].length == 1) {
                return "0" + valSplit[0] + '.' + valSplit[1];
            }
            return value.toFixed(2);
        } else {
            if (value.toString().includes(".")) {
                let [h, m] = value.toString().split(".");
                let hours = h.padStart(2, "0");
                let minutes = m.length === 1 ? m.padStart(2, "0") : m;
                return `${hours}:${minutes}`;
            } else {
                let hours = value.toString().padStart(2, "0");
                return `${hours}:00`;
            }
        }
    }
}

export function getTimeFromDecimal(value: number, decimalFormat: boolean) {
    if (!value) {
        return decimalFormat ? "0.00" : "00:00";
    }

    if (decimalFormat) {
        const valSplit = value.toFixed(2).split(".");
        return (valSplit[0].length === 1 ? "0" + valSplit[0] : valSplit[0]) + "." + valSplit[1];
    }
    let totalMinutes = Math.round(value * 60);

    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;

    if (minutes === 60) {
        hours += 1;
        minutes = 0;
    }
    const h = hours.toString().padStart(2, "0");
    const m = minutes.toString().padStart(2, "0");
    return `${h}:${m}`;
}

export function getStatusByName(status: string) {
    if (status == "Approved") {
        return "record-approved";
    } else if (status == "Rejected") {
        return "record-rejected";
    } else if (status == "Submitted") {
        return "record-submitted";
    } else if (status == "Not Submitted") {
        return "record-not-submitted";
    } else {
        return "no-record";
    }
}

export const getColumnSum = (timeEntriesList: any, showTimeOffInTimesheet: any = false) => {
    let sumArr = [];
    for (var i = 0; i < timeEntriesList.length; i++) {
        let columnSum = new Array(timeEntriesList[i].timeEntries.length - 1);
        for (var j = 0; j < timeEntriesList[i].timeEntries.length; j++) {
            if (timeEntriesList[i].isTimeOff === false || timeEntriesList[i].isTimeOff === "0") {
                columnSum[j] = (sumArr.length > 0 ? sumArr[i - 1][j] : 0) + Number(timeEntriesList[i].timeEntries[j].Hours);
            } else {
                if (showTimeOffInTimesheet) {
                    columnSum[j] = (sumArr.length > 0 ? sumArr[i - 1][j] : 0) + Number(timeEntriesList[i].timeEntries[j].Hours);
                } else {
                    columnSum[j] = (sumArr.length > 0 ? sumArr[i - 1][j] : 0) + 0
                }
            }
            // columnSum[j] = (sumArr.length > 0 ? sumArr[i - 1][j] : 0) + Number(timeEntriesList[i].timeEntries[j].Hours);
        }
        sumArr.push(columnSum)
    }
    return sumArr[sumArr.length - 1];
}

export function getDecimalFromTime(value: any, decimalFormat: boolean) {
    if (decimalFormat) {
        return Number(value);
    } else {

        const [h, m] = value.split(':').map(Number);

        // handle cases like 24:30 or > 23 hours
        if (h > 23 || m > 59) {
            const correctDecimal = h + (m / 60);
            return Number(correctDecimal.toFixed(2));
        }

        // normal valid HH:mm
        const decimal = h + (m / 60);
        return Number(decimal.toFixed(2));
    }
}

export function getDecimalFromTimeInImportTimesheet(value: any, decimalFormat: boolean) {
    // if (decimalFormat) {
    //     return Number(value);
    // } else {

    const [h, m] = value.split(':').map(Number);

    // handle cases like 24:30 or > 23 hours
    if (h > 23 || m > 59) {
        const correctDecimal = h + (m / 60);
        return Number(correctDecimal.toFixed(2));
    }

    // normal valid HH:mm
    const decimal = h + (m / 60);
    return Number(decimal.toFixed(2));
    // }
}

export const getTimeEntryStatus = (approved: boolean, submitted: boolean, validationFailed: boolean) => {
    if (approved) {
        return "record-approved";
    } else if (submitted) {
        return "record-submitted";
    } else if (validationFailed) {
        return "record-validation-failed";
    } else {
        return "record-not-submitted";
    }
}

export function getAccountFeature(systemFeatureId: any) {
    if (systemFeatureId == "537f44e5-ec0f-4de6-aa29-09450961c5e9") {
        return "ExpenseManagement";
    } else if (systemFeatureId == "21e65278-ab96-42c6-a332-16cafbbc669e") {
        return "Attendance";
    } else if (systemFeatureId == "76aaf57e-96a4-4476-94a4-575824e9b9fa") {
        return "TimeOff";
    } else if (systemFeatureId == "27d3a272-d849-4942-9985-7672fb582389") {
        return "ProjectManagement";
    } else if (systemFeatureId == "db17deb7-51a0-4400-bf3b-9094e01ef038") {
        return "TimesheetManagement";
    } else if (systemFeatureId == "deaa2ae5-133d-4c8a-ab0c-b89eaa76116e") {
        return "Billing";
    } else if (systemFeatureId == "9289f75c-48be-4002-bef6-df8be6e014cb") {
        return "Calendar";
    } else if (systemFeatureId == "444fed58-16e0-49a4-8e42-b0e01c5e569b") {
        return "Schedule";
    } else if (systemFeatureId == "356282ab-9aa8-45ae-8d2c-b1a7453a93d4") {
        return "Schedule Report";
    }else if (systemFeatureId == "a8c66b2b-db46-404d-a83f-fe797d349788") {
        return "GeoFence Setup";
    } else {
        return "no-record";
    }
}


export const getProfileSettingForDevelopmentMode = () => {
    return {
        "AccountEmployeeId": 99353,
        "CurrentDate": "2023-05-15T00:00:00",
        "DecimalFormat": false,
        "IsPercentageFormat": true,
        "TimeEntryViewType": "BiWeekly",
        "IsTimesheetPolicy": false,
        "ShowDescription": true,
        "AccountWorkingDayTypeId": "c5c6a043-ef0f-484b-b206-744bcd56e7de",
        "NumberOfBlankRowsInTimesheet": 2,
        "NumberOfBlankRowsInTimeoff": 1,
        "CurrentCultureDateFormat": "M/d/yyyy",
        "CustomFieldsTemplate": [
            {
                "AccountCustomFieldId": "c328323b-400e-48c9-a982-5b2f456ab2d0",
                "AccountId": 13101,
                "MasterCustomDataTypeId": "7e295184-9623-4445-b99f-48f07929dce5",
                "DatabaseFieldName": "CustomField1",
                "CustomFieldName": "Reference",
                "CustomFieldCaption": "Reference",
                "DefaultValue": "1",
                "MaximumLength": null,
                "MinimumValue": null,
                "MaximumValue": null,
                "DropDownOptions": null,
                "IsRequired": true,
                "IsDisabled": false,
                "MasterEntityTypeId": "369ed0fb-d317-4244-9f20-b7d834521e2b",
                "MasterEntityTypeName": "Timesheet",
                "MasterCustomDataTypeName": "Text",
                "MasterEntityValidationGroup": null
            },
            {
                "AccountCustomFieldId": "7b92c362-8ab3-4e9c-a38f-780f3a52e478",
                "AccountId": 13101,
                "MasterCustomDataTypeId": "bacd6824-9011-4c30-864f-0899fefc004f",
                "DatabaseFieldName": "CustomField2",
                "CustomFieldName": "Number Field",
                "CustomFieldCaption": "Number Field",
                "DefaultValue": "1",
                "MaximumLength": null,
                "MinimumValue": 1,
                "MaximumValue": 10,
                "DropDownOptions": null,
                "IsRequired": true,
                "IsDisabled": false,
                "MasterEntityTypeId": "369ed0fb-d317-4244-9f20-b7d834521e2b",
                "MasterEntityTypeName": "Timesheet",
                "MasterCustomDataTypeName": "Number",
                "MasterEntityValidationGroup": null
            },
            {
                "AccountCustomFieldId": "9e1e84ab-8940-4e6f-b403-9bc670d7714c",
                "AccountId": 13101,
                "MasterCustomDataTypeId": "7e295184-9623-4445-b99f-48f07929dce5",
                "DatabaseFieldName": "CustomField3",
                "CustomFieldName": "1",
                "CustomFieldCaption": "1",
                "DefaultValue": "1",
                "MaximumLength": 1,
                "MinimumValue": null,
                "MaximumValue": null,
                "DropDownOptions": null,
                "IsRequired": true,
                "IsDisabled": true,
                "MasterEntityTypeId": "369ed0fb-d317-4244-9f20-b7d834521e2b",
                "MasterEntityTypeName": "Timesheet",
                "MasterCustomDataTypeName": "Text",
                "MasterEntityValidationGroup": null
            },
            {
                "AccountCustomFieldId": "0e235aa7-866a-49c9-b71f-20ecdb71bda9",
                "AccountId": 13101,
                "MasterCustomDataTypeId": "574ded9c-7ad4-4649-8b39-d6741dd0ddca",
                "DatabaseFieldName": "CustomField4",
                "CustomFieldName": "Country",
                "CustomFieldCaption": "Country",
                "DefaultValue": "India",
                "MaximumLength": null,
                "MinimumValue": null,
                "MaximumValue": null,
                "DropDownOptions": "Pakistan+India",
                "IsRequired": true,
                "IsDisabled": false,
                "MasterEntityTypeId": "369ed0fb-d317-4244-9f20-b7d834521e2b",
                "MasterEntityTypeName": "Timesheet",
                "MasterCustomDataTypeName": "Drop-Down",
                "MasterEntityValidationGroup": null
            },
            {
                "AccountCustomFieldId": "da5ba4a1-6795-4688-bb83-04d1d9fbcaa3",
                "AccountId": 13101,
                "MasterCustomDataTypeId": "5942a0be-e7fe-4abb-b96f-f0b20d744ce3",
                "DatabaseFieldName": "CustomField5",
                "CustomFieldName": "Date Field",
                "CustomFieldCaption": "Date Field",
                "DefaultValue": "",
                "MaximumLength": null,
                "MinimumValue": null,
                "MaximumValue": null,
                "DropDownOptions": null,
                "IsRequired": true,
                "IsDisabled": false,
                "MasterEntityTypeId": "369ed0fb-d317-4244-9f20-b7d834521e2b",
                "MasterEntityTypeName": "Timesheet",
                "MasterCustomDataTypeName": "Date",
                "MasterEntityValidationGroup": null
            }
        ],
        "TimeEntryFormat": "HH:mm",
        "ShowProjectForTimeOff": false,
        "ShowClientInTimesheet": true,
        "ShowWorkTypeInTimeSheet": true,
        "ShowClockStartEnd": false,
        "ShowCostCenterInTimeSheet": true,
        "AccessToken": "3a76ea57-8135-4b3e-a492-95167e197e88",
        "AccountId": 13101,
        "EmployeeName": "Muhammad Rameez",
        "EmployeeInitials": "MR",
        "AccountRoleId": 102404,
        "EnableTimerInTimesheet": true
    }
}


export function setTaskStatus(status: string) {
    if (status == "Started") {
        return "badge-light-primary"
    } else if (status == "OnHold") {
        return "badge-light-warning"
    } else if (status == "In Progress") {
        return "badge-light-info"
    }
    else if (status == "Completed") {
        return "badge-light-success"
    }
}

// export const formatDateWithMonthName = (date: any) => {
//     return moment(date).format("ddd")
// }

export const formatDays = (date: any) => {
    // if (!date) return "";
    // const browserLocale = navigator.language?.toLowerCase() || "";
    // // Only convert Thai Buddhist calendar year to Gregorian
    // if (browserLocale.startsWith("th")) {
    //     // if (locale.toLowerCase().startsWith("th")) {
    //     const [year, month, day] = String(date).split("-");
    //     const parsedYear = Number(year);
    //     if (parsedYear > 2400) {
    //         date = `${parsedYear - 543}-${month}-${day}`;
    //     }
    // }
    return moment(date).format("ddd");
}

export const formatDateAndMonth = (date: any) => {
    return moment(date).format("DD MMM")
}

export const formatDateWithDateAndMonthName = (date: any) => {
    return moment(date).format("MMM DD, YYYY")
}

export const timeConverIntoSeconds = (time: any) => {
    let a = time.split(':');
    // let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;
    return seconds
}

export const getTimeEntryHoursFormat = (TimeEntryHoursFormatId: string) => {
    if (TimeEntryHoursFormatId === '074187eb-81d9-4e06-8e70-db7bc0c53784') {
        return 'Time';
    } else if (TimeEntryHoursFormatId === 'ee9cb3b1-e1a1-4346-b9fc-a3da1c92a45e') {
        return 'Decimal';
    } else {
        return 'Time';
    }
}

export const getTimesheetApprovalStatus = () => {
    return [{ "value": 0, "label": "All Timesheet Periods" },
    { "value": 1, "label": "All Open Timesheet Periods" },
    { "value": 2, "label": "Not Submitted" },
    { "value": 3, "label": "Submitted" },
    { "value": 4, "label": "Approved" },
    { "value": 5, "label": "Rejected" }];
}

export const getTimesheetTimesheetEntered = () => {
    return [{ "value": 1, "label": "Entered" },
    { "value": 2, "label": "Both" },
    { "value": 3, "label": "Not Entered" }];
}